import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Download, Printer } from "lucide-react";
import api, { API, authToken } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { SideReader } from "../../components/SideReader";

export default function SideReaderPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const [side, setSide] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/sides/${id}`).then((r) => setSide(r.data)).catch(() => setNotFound(true));
  }, [id]);

  const pdfUrl = `${API}/sides/${id}/download?auth=${authToken()}`;

  if (notFound) return <p className="font-sans text-sm text-stone">Side not found.</p>;
  if (!side) return <p className="font-sans text-sm text-stone">Loading…</p>;

  return (
    <div className="space-y-6" data-testid="side-reader-page">
      <div className="flex flex-wrap items-center justify-between gap-4 no-print">
        <Link to="/portal/sides" className="btn-ghost text-sm" data-testid="back-to-sides">
          <ArrowLeft size={15} /> Back to sides
        </Link>
        <div className="flex gap-3">
          <button onClick={() => window.print()} className="btn-outline text-sm" data-testid="print-side">
            <Printer size={15} /> Print
          </button>
          <button onClick={() => window.open(pdfUrl, "_blank")} className="btn-brass text-sm" data-testid="open-side-pdf">
            <Download size={15} /> PDF
          </button>
        </div>
      </div>

      <div>
        <p className="overline mb-1 no-print">Sides</p>
        <h1 className="font-serif text-3xl text-ink no-print">{side.title}</h1>
      </div>

      {side.script ? (
        <SideReader
          script={side.script}
          watermarkName={user?.name}
          title={side.title}
          pageLabel={`1 of ${side.page_count}`}
        />
      ) : (
        <iframe
          title={side.title}
          src={pdfUrl}
          className="w-full h-[80vh] border border-hairline bg-white"
          data-testid="side-pdf-frame"
        />
      )}
    </div>
  );
}
